import $ from 'jquery';

export class ajaxLoader {

    constructor() {

        this.$btnWrapper = $('.load-more');

        this.loadMore();

    }

    // load items
    loadMore() {

        // load more btn
        let $link = this.$btnWrapper.find('a');

        $link.on('click', function (e) {
            e.preventDefault();

            let $this = $(this);
            let $start = $this.data('start');
            let $limit = $this.data('limit');
            let $append = $this.data('append'); // data append container
            let filter = window.localStorage.getItem('filter-id');

            // loading class
            $(this).addClass('loading');

            // ajax request
            $.ajax({
                type: 'POST',
                url: $this.attr('href'),
                data: {
                    start: $start,
                    limit: $limit,
                    filter: filter
                },
            }).done((data) => {

                if (data) {

                    let $container = $($append).find('.row');
                    $container.append(data);
                    $this.removeClass('loading');
                    $this.data('start', $start + $limit);

                    // hide btn
                    let items = $container.find('.item');
                    let last = $container.find('.item--last');
                    if (last.length) {
                        $this.hide();
                    }

                }
                else {
                }


            });

            return false;
        });

    }

    // update list - replace item rows in html
    updateList($list) {

        let filter = window.localStorage.getItem('filter-id');
        let $link = this.$btnWrapper.find('a');
        let $start = $link.data('start');

        $.ajax({
            type: 'POST',
            data: {
                filter: filter
            },
        }).done((data) => {

            let $container = $($list).find('.container');
            $container.html(data);

            // hide btn
            let rows = $container.find('.reference-item');
            let last = $container.find('.reference-item--last');

            console.log(rows.length < $start);

            if (last.length || rows.length < $start) {
                $link.hide();
            }
            else {
                $link.show();
            }


        });
    }

    // update list - replace item rows in html
    updateGrid($grid) {

        let filter = window.localStorage.getItem('filter-id');
        let $link = this.$btnWrapper.find('a');
        let $start = $link.data('start');

        $.ajax({
            type: 'POST',
            data: {
                filter: filter
            },
        }).done((data) => {

            let $container = $($grid).find('.row');

            console.log($container);

            $container.html(data);

            // hide btn
            let rows = $container.find('.reference-item');
            let last = $container.find('.reference-item--last');

            console.log(rows.length < $start);

            if (last.length || rows.length < $start) {
                $link.hide();
            }
            else {
                $link.show();
            }


        });

    }

}